import React from "react";
import { Field, TextInput, Textarea, Select, Honeypot, SubmitRow, Confirmation } from "./Form";
import { useFormState, useSubmit, firstErrorFocus } from "../hooks/useForm";
import { requiredError, emailError } from "../lib/workEmail";

const PROGRAMMES = [
  { value: "fellowship", label: "Fellowship" },
  { value: "adoption-leadership", label: "Adoption Leadership" },
  { value: "adoption-policy", label: "Adoption Policy" },
  { value: "not-sure", label: "Not sure" },
];

const INITIAL = {
  executive_name: "",
  role: "",
  organisation: "",
  country: "",
  email: "",
  nominated_by_name: "",
  nominated_by_role: "",
  nominated_by_email: "",
  programme: "",
  decision: "",
  hp: "",
};

export default function NominationForm() {
  const { values, errors, setErrors, update } = useFormState(INITIAL);
  const { pending, done, serverError, submit } = useSubmit("nomination");

  const onSubmit = async (e) => {
    e.preventDefault();
    const next = {
      executive_name: requiredError(values.executive_name),
      role: requiredError(values.role),
      organisation: requiredError(values.organisation),
      country: requiredError(values.country),
      email: emailError(values.email),
      nominated_by_name: requiredError(values.nominated_by_name),
      nominated_by_role: requiredError(values.nominated_by_role),
      nominated_by_email: emailError(values.nominated_by_email),
      programme: requiredError(values.programme),
    };
    setErrors(next);
    if (Object.values(next).some(Boolean)) return firstErrorFocus(next);
    const t = (k) => values[k].trim();
    await submit({
      executive_name: t("executive_name"),
      role: t("role"),
      organisation: t("organisation"),
      country: t("country"),
      email: t("email"),
      nominated_by_name: t("nominated_by_name"),
      nominated_by_role: t("nominated_by_role"),
      nominated_by_email: t("nominated_by_email"),
      programme: values.programme,
      decision: t("decision") || null,
      hp: values.hp,
    });
  };

  if (done) {
    return <Confirmation testId="nomination-confirmation">Thank you. The Fellowship team will be in touch about the next intake.</Confirmation>;
  }

  return (
    <form onSubmit={onSubmit} className="form" noValidate data-testid="nomination-form">
      <div className="form-row">
        <Field label="Executive's name" htmlFor="executive_name" error={errors.executive_name}>
          <TextInput id="executive_name" name="executive_name" value={values.executive_name} onChange={update("executive_name")} invalid={!!errors.executive_name} testId="nom-executive-name" />
        </Field>
        <Field label="Role" htmlFor="role" error={errors.role}>
          <TextInput id="role" name="role" value={values.role} onChange={update("role")} invalid={!!errors.role} testId="nom-role" />
        </Field>
      </div>
      <div className="form-row">
        <Field label="Organisation" htmlFor="organisation" error={errors.organisation}>
          <TextInput id="organisation" name="organisation" value={values.organisation} onChange={update("organisation")} autoComplete="organization" invalid={!!errors.organisation} testId="nom-organisation" />
        </Field>
        <Field label="Country" htmlFor="country" error={errors.country}>
          <TextInput id="country" name="country" value={values.country} onChange={update("country")} autoComplete="country-name" invalid={!!errors.country} testId="nom-country" />
        </Field>
      </div>
      <Field label="Work email" htmlFor="email" error={errors.email}>
        <TextInput id="email" name="email" type="email" value={values.email} onChange={update("email")} invalid={!!errors.email} testId="nom-email" />
      </Field>

      <div className="form-group">
        <span className="mono-label form-group-label">Nominated by</span>
        <div className="form-row">
          <Field label="Name" htmlFor="nominated_by_name" error={errors.nominated_by_name}>
            <TextInput id="nominated_by_name" name="nominated_by_name" value={values.nominated_by_name} onChange={update("nominated_by_name")} autoComplete="name" invalid={!!errors.nominated_by_name} testId="nom-by-name" />
          </Field>
          <Field label="Role" htmlFor="nominated_by_role" error={errors.nominated_by_role}>
            <TextInput id="nominated_by_role" name="nominated_by_role" value={values.nominated_by_role} onChange={update("nominated_by_role")} autoComplete="organization-title" invalid={!!errors.nominated_by_role} testId="nom-by-role" />
          </Field>
        </div>
        <Field label="Work email" htmlFor="nominated_by_email" error={errors.nominated_by_email}>
          <TextInput id="nominated_by_email" name="nominated_by_email" type="email" value={values.nominated_by_email} onChange={update("nominated_by_email")} autoComplete="email" invalid={!!errors.nominated_by_email} testId="nom-by-email" />
        </Field>
      </div>

      <Field label="Programme of interest" htmlFor="programme" error={errors.programme}>
        <Select id="programme" name="programme" value={values.programme} onChange={update("programme")} options={PROGRAMMES} invalid={!!errors.programme} testId="nom-programme" />
      </Field>
      <Field label="One sentence on the adoption decision they are facing" htmlFor="decision" optional>
        <Textarea id="decision" name="decision" rows={3} value={values.decision} onChange={update("decision")} maxLength={500} testId="nom-decision" />
      </Field>
      <Honeypot value={values.hp} onChange={update("hp")} />
      <SubmitRow pending={pending} label="Nominate" testId="nom-submit" error={serverError} />
    </form>
  );
}
